$(document).on("click", ".new-faq-title", function(){
  if($(this).hasClass("active")){
    $(this).toggleClass("active");
    $(this).next(".new-faq-text").slideToggle(200);
  }
  else{
    $(".new-faq-title").removeClass("active");
    $(".new-faq-text").slideUp(200);
    $(this).addClass("active");
    $(this).next(".new-faq-text").slideDown(200);
  }
})

$(document).on("click", ".new-prod-btn", function(){
  let arr = [];
  if($(this).attr("data-sp") == "none"){
    arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
  }
  else{
    arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1, 'selling_plan': $(this).attr("data-sp") });
  }
  AddProdToCart(arr, $(this));
})

function AddProdToCart(productsArr, $this){
  $this.addClass("active");
  let formData = {
    'items': productsArr,
    sections: "cart-drawer,cart-icon-bubble"
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(res => {
    if(res.status){
      console.log(res);
    }
    else{
      window.upcartOpenCart();
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
    $this.removeClass("active");
  });
}